import { render } from "./OrderSheetsIndex.vue?vue&type=template&id=c5a9b978"
import script from "./OrderSheetsIndex.vue?vue&type=script&lang=js"
export * from "./OrderSheetsIndex.vue?vue&type=script&lang=js"

import "./OrderSheetsIndex.vue?vue&type=style&index=0&id=c5a9b978&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__